import { FEATURE_FLAGS } from "../constants";
import { messageGraph } from "../services/messageGraph";

/**
 * Returns the message list to render.
 *
 * When USE_MESSAGE_GRAPH is true, reads from the singleton MessageGraph
 * (ordered by createdAt, deduped by id). Redux messagesList is still used as
 * the reactivity signal — dispatching setMessagesList/addNewMessage triggers
 * a re-render, at which point this hook reads the graph's up-to-date state.
 *
 * When the flag is false, returns the raw Redux messagesList unchanged.
 */
export function useGraphMessages(
  chatId: string | undefined,
  reduxMessages: any[],
): any[] {
  if (!FEATURE_FLAGS.USE_MESSAGE_GRAPH || !chatId) return reduxMessages;

  const graphMessages = messageGraph.getOrdered(chatId);

  // Temp messages (in-flight sends) live only in Redux — they are never
  // mirrored to the graph. Append them so the user sees their own sent
  // messages instantly. Once the socket echo arrives and replaces the temp
  // in Redux (via addNewMessage dedup logic), the temp disappears naturally.
  const temps = reduxMessages.filter((m: any) => m.isTempMsg);
  if (!temps.length) return graphMessages;

  const graphIds = new Set(graphMessages.map((m: any) => String(m.id)));
  const unmirrored = temps.filter((m: any) => !graphIds.has(String(m.id)));
  return unmirrored.length ? [...graphMessages, ...unmirrored] : graphMessages;
}
